<template>
  <div
    :class="[
      // 创建独立的层叠上下文避免after被遮挡
      'isolate',
      'lg:w-fit w-full',
      'group/press-btn',
      'lg:text-lg text-md font-semibold **:uppercase',
      'select-none',
      props.btnClass,
    ]"
    @mouseenter="isShowIcon = true"
    @mouseleave="isShowIcon = false"
  >
    <LayoutGroup v-if="type === 1">
      <Motion
        as="button"
        layout
        :class="[
          // 基础样式
          'relative flex justify-center items-center px-4 py-2.5 size-full text-white cursor-pointer hover:shadow-lg shadow-primary/50 active:shadow-none bg-primary hover:-translate-y-1.5 active:translate-y-0',
          // 过渡
          'before:transition-[height] transition-[translate]',
          // 底部的横线进度条
          'before:absolute before:left-0 before:bottom-0 before:translate-y-full before:h-0 before:w-full before:-z-1 before:bg-[rgb(220,80,10)] before: before:ease hover:before:h-1.5 active:before:h-0',
          // 按下时
          'active:brightness-90 active:before:border-b-0',
        ]"
      >
        <Motion v-if="props.leadingIcon" layout class="flex items-center justify-center">
          <UIcon v-if="isShowIcon" :name="props.leadingIcon" />
        </Motion>

        <Motion as="span" layout>
          {{ props.label }}
        </Motion>

        <Motion v-if="props.trallingIcon" layout class="flex items-center justify-center">
          <UIcon v-if="isShowIcon" :name="props.trallingIcon" />
        </Motion>
      </Motion>
    </LayoutGroup>

    <LayoutGroup v-else-if="type === 2">
      <Motion
        as="button"
        layout
        :class="[
          // 基础样式
          'relative flex justify-center items-center px-4 py-2.5 size-full text-primary hover:text-white cursor-pointer ring hover:ring-0 hover:shadow-lg shadow-primary/50 active:shadow-none hover:-translate-y-1.5 active:translate-y-0',
          // 过渡
          'before:transition-[height] transition-[translate]',
          // 撑满的大面积背景色
          'after:absolute after:left-0 after:top-0 after:h-full after:w-0 after:-z-2 after:bg-primary after:ease hover:after:w-full',
          // 底部的横线进度条
          'before:absolute before:left-0 before:bottom-0 before:translate-y-full before:h-0 before:w-full before:-z-1 before:bg-[rgb(220,80,10)] before:ease hover:before:h-1.5 active:before:h-0',
          // 给第二个动画一点等待缓冲
          //   'hover:before:delay-300',
          // 按下时
          'active:brightness-90 active:before:border-b-0',
        ]"
      >
        <Motion v-if="props.leadingIcon" layout class="flex items-center justify-center">
          <UIcon v-if="isShowIcon" :name="props.leadingIcon" />
        </Motion>

        <Motion as="span" layout>
          {{ props.label }}
        </Motion>

        <Motion v-if="props.trallingIcon" layout class="flex items-center justify-center">
          <UIcon v-if="isShowIcon" :name="props.trallingIcon" />
        </Motion>
      </Motion>
    </LayoutGroup>

    <!-- https://uiverse.io/adamgiebl/pink-chicken-70 -->
    <LayoutGroup v-else-if="type === 3">
      <Motion
        as="button"
        class="relative inline-flex items-center justify-center overflow-hidden border-none bg-linear-to-r from-primary to-secondary tracking-wider cursor-pointer active:scale-95 active:brightness-75 transition-transform hover:shadow-lg shadow-primary/50"
      >
        <Motion
          class="absolute top-0 -left-1/10 z-0 h-full w-6/5 skew-x-30 bg-primary ring transition-transform ease-in-out group-hover/press-btn:translate-x-full"
        />

        <Motion
          as="span"
          layout
          class="relative z-10 inline-flex items-center px-4 py-2.5 transition-colors"
        >
          <Motion v-if="props.leadingIcon" layout class="flex items-center justify-center">
            <UIcon v-if="isShowIcon" :name="props.leadingIcon" />
          </Motion>

          <Motion as="span" layout>
            {{ props.label }}
          </Motion>

          <Motion v-if="props.trallingIcon" layout class="flex items-center justify-center">
            <UIcon v-if="isShowIcon" :name="props.trallingIcon" />
          </Motion>
        </Motion>
      </Motion>
    </LayoutGroup>

    <!-- https://uiverse.io/Wendell47/gentle-cheetah-21 -->
    <LayoutGroup v-else-if="type === 4">
      <Motion
        as="button"
        class="relative inline-flex items-center justify-center px-4 py-2.5 border-0 overflow-hidden cursor-pointer text-white z-0 shadow-[0_0px_7px_-5px_rgba(0,0,0,0.5)] hover:brightness-110 bg-secondary active:scale-97 rounded-sm active:brightness-75"
      >
        <Motion v-if="props.leadingIcon" layout class="flex items-center justify-center">
          <UIcon v-if="isShowIcon" :name="props.leadingIcon" />
        </Motion>

        <Motion as="span" layout>
          {{ props.label }}
        </Motion>

        <Motion v-if="props.trallingIcon" layout class="flex items-center justify-center">
          <UIcon v-if="isShowIcon" :name="props.trallingIcon" />
        </Motion>

        <Motion layout class="absolute inset-0 flex items-center justify-center z-[-1]">
          <div
            class="size-40 rounded-[40rem] blur-[20px] bg-linear-to-r from-primary to-secondary group-hover/press-btn:size-32"
            style="animation: spin 3s linear infinite"
          />
        </Motion>
      </Motion>
    </LayoutGroup>
  </div>
</template>

<script setup lang="ts">
  interface Props {
    label: string
    type?: number
    btnClass?: string
    leadingIcon?: string
    trallingIcon?: string
  }

  const props = withDefaults(defineProps<Props>(), {
    label: '',
    type: 1,
  })

  const isShowIcon = ref(false)
</script>
